import { WebAPIClient } from "api";
import { ApiEndPoints } from "api/api-end-points";
import { APIResult } from "models/api-results";
import { BaseSearchParam } from "models/base-search-param";

import { Customer } from "models/customer";
import { CustomerFilterParam } from "models/customer/customerFilterParam";

export async function GetCustomers(param?: CustomerFilterParam, sort?: string, pageSize?: number, pageNumber?: number): Promise<APIResult<Customer[]>> {
    const searchParams = new BaseSearchParam(param, sort, pageSize, pageNumber);
    const queryString = searchParams.buildQueryString();

    const apiUrl = `${ApiEndPoints.customer_search}${queryString}`;
    return await WebAPIClient.getData<Customer[]>(apiUrl);
}


export async function CreateCustomer(param: Customer): Promise<APIResult<Customer>> {
    return await WebAPIClient.postData<Customer>(ApiEndPoints.customer_create, param);
}
export async function UpdateCustomer(param: Customer): Promise<APIResult<Customer>> {
    return await WebAPIClient.putData<Customer>(ApiEndPoints.customer_update.replace("{id}", (param?.id ?? 0).toString()), param);
}